import React, {Component, Fragment} from 'react';
import {matchPath } from 'react-router-dom';
import {
  Layout,
  Select,
  Steps,
  Icon,
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Button,
  Spin,
  Alert,
  Divider,
  notification,
  Timeline,
  Progress
} from 'antd';
import {inject, observer} from "mobx-react";
import styles from './styles.module.css';
import QRCode from 'qrcode.react';
import Clipboard from 'react-clipboard.js';

const {Content} = Layout;
const {Option} = Select;
const {Step} = Steps;

const steps = [{
  title: 'Login',
  status: '',
  icon: '',
  nextbtn: 'Continue'
}, {
  title: 'Choose Coins',
  nextbtn: 'Next'
}, {
  title: 'Recipient',
  nextbtn: 'Next'
}, {
  title: 'Confirmation',
  nextbtn: 'Confirm & Make Payment'
}, {
  title: 'Sending',
  nextbtn: 'Next'
}, {
  title: 'Exchanging',
  nextbtn: 'Done'
}];

class Exchange extends Component {

      state = {
        currencies: [],
        from_minimum: 0,
        from: null,
        from_amt: 50,
        to: null,
        to_amt: 0,
        to_address: null,
        step: 0,
        address_validation_status: null,
        allow_next: true,
        allow_prev: true,
        trx_error: null,
        trx_id: null,
        trx_data: null,
        trx_busy: false,
        trx_estimate: []
      }

      componentWillMount = () => {
        this._mounted = true;
        this._checker = setInterval(this.trxChecker, 15000);
        this.checkProps(this.props);
      }

      componentWillReceiveProps = (np) => {
        this.checkProps(np);
      }

      trxChecker = () => {
        if(this.state.trx_id && this.state.trx_data) {
          this.fetchTrxStatus();
        }
      }

      checkProps(props) {
        let match = matchPath(props.location.pathname, { path: '/exchange/convert/:from/:to/:amount?', exact: true });
        if(match) {
          let from_amt = match.params.amount ? match.params.amount : this.state.from_amt;
          this.setState({ from: match.params.from, to: match.params.to, from_amt: from_amt, allow_prev: false, step: 1 }, () => {
            this.onStep(1, true);
          });
        } else {
          match = matchPath(props.location.pathname, { path: '/exchange/trx/:trx_id', exact: true });
          if(match) {
            this.setState({ trx_id: match.params.trx_id, allow_prev: false, allow_next: false, trx_busy: true, step: 4 }, () => {
              this.onStep(4, true);
            });
          } else {
            match = matchPath(props.location.pathname, { path: '/exchange', exact: true });
            if(match) {
             this.setState({ step: 0 }, () => {
               this.onStep(0, true);
             });
           }
          }
        }
      }

      componentWillUnmount = () => {
        this._mounted = false;
        clearInterval(this._checker);
        this._checker = null;
      }

      isInvalidFromTo() {
        if(this.state.from === null || this.state.to === null) return true;
        if(this.getCurrencyBySymbol(this.state.from) === null || this.getCurrencyBySymbol(this.state.to) === null) return true;
        return false;
      }

      onStep(step, history) {
        switch(step) {
          case 0:
          default:
            if(this.props.main.authenticated) {
              this.setState({ step: 1 }, () => { this.onStep(1, true); });
            } else {
              if(this._mounted) {
                this.setState({ allow_next: true, from: null, to: null });
                if(!history) this.props.history.push('/exchange');
              }
            }
          break;
          case 1:
            this.setState({ allow_next: false, allow_prev: true });
            this.props.main.fetchExchangeCurrencies().then((data) => {
              if(this._mounted) {
                this.setState({currencies: data});
                if(this.isInvalidFromTo()) {
                  this.setState({from: data[0].name, to: data[1].name});
                  this.props.history.push('/exchange/convert/'+data[0].name + '/' + data[1].name);
                  this.fetchMinimumForSelected(data[0].name, data[1].name);
                } else {
                  this.fetchMinimumForSelected(this.state.from, this.state.to);
                }
              }
            })
          break;
          case 2:
            this.setState({ allow_next: false, allow_prev: true });
            this.validateAddress();
          break;
          case 3:
            this.setState({ allow_next: false, trx_id: null, trx_data: null, trx_error: null });
            setTimeout(()=>{
              if(this.state.step === 3)
              this.setState({ allow_next: true });
            }, 1000);
          break;
          case 4:
            if(!history) {
              this.setState({ allow_prev: false, allow_next: false, trx_busy: true });
              this.initiateTransaction();
            } else {
              this.fetchTrxStatus();
            }
          break;
          case 5:
            this.setState({ allow_prev: false, allow_next: false });
          break;
        }
      }

      initiateTransaction() {
        this.props.main.initiateTransaction(this.state.from, this.state.to, this.state.from_amt, this.state.to_amt, this.state.to_address, null).then((trx_id) => {
          if(this._mounted) {
            this.setState({ allow_prev: false, allow_next: true, trx_error: null, trx_id: trx_id });
            this.props.history.push('/exchange/trx/' + trx_id);
          }
        }).catch((error) => {
          if(error.response.status === 400) {
            this.setState({ allow_prev: true, allow_next: false, trx_busy: false, trx_error: error.response.data.error.message });
          } else {
            this.setState({ allow_prev: true, allow_next: false, trx_busy: false, trx_error: error.message });
          }
        });
      }

      fetchTrxStatus() {
        if(this.state.trx_id != null) {
          this.props.main.fetchTrxStatus(this.state.trx_id).then((data) => {
            if(data) {
              if(data.status === 'new') {
                this.setState({trx_busy: false, trx_data: data});
              } else {
                this.setState({trx_busy: false, trx_data: data, step: 5}, ()=> {
                  this.onStep(5);
                });
              }
            } else {
              this.setState({trx_busy: false, trx_data: data, step: 5});
            }
          }).catch((error) => {
            this.setState({trx_busy: false, trx_error: error.message });
          })
        }
      }

      nextStep() {
        const current = this.state.step + 1;
        this.setState({step: current});
        this.onStep(current);
      }

      prevStep() {
        const current = this.state.step - 1;
        this.setState({step: current});
        this.onStep(current);
      }

      handleFromDropdownChange = (e) => {
        this.setState({from: e});
        this.props.history.push('/exchange/convert/'+ e + '/' + this.state.to);
        this.fetchMinimumForSelected(e, this.state.to);
      }

      handleToDropdownChange = (e) => {
        this.setState({to: e});
        this.props.history.push('/exchange/convert/'+ this.state.from + '/' + e);
        this.fetchMinimumForSelected(this.state.from, e);
      }

      handleAddressChange = (e) => {
        this.setState({to_address: e.target.value});
      }

      handleFromNumberChange = (e) => {
        if (e) {
          const s = e.toString();
          if (s.length > 0 && s[s.length - 1] !== '.') {
            const n = s.replace(/[^0-9.]/g, '');
            if (n.length > 0) {
              this.setState({from_amt: n});
              this.fetchConversionForSelected(this.state.from, this.state.to, n);
            } else {
              this.setState({from_amt: this.state.from_minimum});
            }
          }
        }
      }

      fetchMinimumForSelected = (from, to) => {
        if(this._mounted === true) {
          this.setState({ allow_next: false });
          this.props.main.fetchMinimumAmount(from, to).then((data) => {
            const amt = this.state.from_amt < Number(data)
              ? Number(data)
              : this.state.from_amt;
            this.setState({from_minimum: Number(data), from_amt: amt});
            this.fetchConversionForSelected(from, to, amt);
            this.fetchDeliveryEstimate(from, to);
          })
        }
      }

      fetchDeliveryEstimate = (from, to) => {
        this.props.main.fetchDeliveryEstimate(from, to).then((data) => {
          if(this._mounted === true)
          this.setState({trx_estimate: data});
        })
      }

      fetchConversionForSelected = (from, to, from_amt) => {
        this.props.main.fetchConversionAmount(from, to, from_amt).then((data) => {
          if(this._mounted === true) {
            this.setState({to_amt: Number(data), allow_next: true});
          }
        })
      }

      getCurrencyBySymbol(symbol) {
        const c = this.state.currencies;
        for (let i = 0; i < c.length; i++) {
          if (c[i].name.toUpperCase() === symbol.toUpperCase()) {
            return c[i];
          }
        }
        return null;
      }

      getFromDropdown = () => {
        const c = this.state.currencies;
        const children = [];
        for (let i = 0; i < c.length; i++) {
          if (c[i].name !== this.state.to) {
            children.push(<Option value={c[i].name} key={'from' + c[i].name}>{c[i].fullName + " (" + c[i].name.toUpperCase() + ")"}</Option>);
          }
        }
        return children.length > 0 ? <Select size="large" key={this.state.from} showSearch optionFilterProp="children" defaultValue={this.state.from} onChange={this.handleFromDropdownChange} style={{
            width: '50%',
            maxWidth: 150
          }}>
          {children}
        </Select> : null;
      }

      getToDropdown = () => {
        const c = this.state.currencies;
        const children = [];
        for (let i = 0; i < c.length; i++) {
          if (c[i].name !== this.state.from) {
            children.push(<Option value={c[i].name} key={'to' + c[i].name}>{c[i].fullName + " (" + c[i].name.toUpperCase() + ")"}</Option>);
          }
        }
        return children.length > 0 ? <Select size="large" key={this.state.to} showSearch optionFilterProp="children" defaultValue={this.state.to} onChange={this.handleToDropdownChange} style={{
            width: '50%',
            maxWidth: 150
          }}>
          {children}
        </Select> : null;
      }

      validateAddress = () => {
        if(this.state.to_address && this.state.to_address.length > 0) {
          this.setState({
            address_validation_status: 'validating',
            allow_next: false
          })
          this.props.main.validateAddress(this.state.from, this.state.to_address, null).then((data) => {
            this.setState({
              address_validation_status: data === true ? 'success' : 'error',
              allow_next: data
            })
          })
        } else {
          this.setState({
            address_validation_status: null,
            allow_next: false
          })
        }
      }

      getDeliveryEstimate = () => {
        let estimate = this.state.trx_estimate;
        let retval = [];
        for (var i = 0; i < estimate.length; i++) {
          retval.push(<div key={'estimate'+i} className={styles.estimate}><Icon type={estimate[i].icon} style={{color: estimate[i].color }} /><span>{estimate[i].message}</span></div>)
        }
        return retval;
      }

  /*  <Col md={{span: 24}} lg={{span: 6}}>
      <div className={styles.label}>FAQ:</div>
      <ul className={styles.plain}>
        <li><a href="#">What's a wallet address?</a></li>
        <li><a href="#">How do I get a new address?</a></li>
      </ul>
    </Col>*/

      renderStep(step) {
        let retval;
        switch (step) {
          case 0:
          default:
            retval = (
              <Row gutter={32} type="flex" justify="center">
                <Col md={{span: 24}} lg={{span: 12}} style={{textAlign: "center"}}>
                  <h2>Sign in now (optional)</h2>
                  <div>We will save your transaction history</div>
                  <Button type="primary" icon="login" onClick={()=>{ this.props.main.login(); }}>Login</Button>
                  <Divider>OR</Divider>
                  Continue using the exchange anonymously
                  </Col>
              </Row>
            );
          break;
          case 1:
            retval = (
              <Row gutter={32}>
                <Col md={{span: 24}} lg={{span: 18}} className={styles.amountsForm}>
                  <Form>
                    <div className={styles.label}>YOU HAVE:</div>
                    <Form.Item help={this.state.from_minimum === 0
                        ? '...'
                        : 'Minimum ' + this.state.from_minimum + " " + (this.state.from || '').toUpperCase()}>
                      <Input.Group size="large" compact="compact" style={{
                          display: 'flex'
                        }}>
                        <InputNumber defaultValue={this.state.from_amt} min={this.state.from_minimum} size="large" style={{
                            flex: 1,
                            width: 'auto',
                            marginRight: 0
                          }} onChange={this.handleFromNumberChange} value={this.state.from_amt}/> {this.getFromDropdown()}
                      </Input.Group>
                    </Form.Item>

                    <div className={styles.label}>YOU RECEIVE:</div>
                    <Form.Item help='Includes exchange fee: 0.75%'>
                      <Input.Group size="large" compact="compact" style={{
                          display: 'flex'
                        }}>
                        <Input style={{
                            flex: 1,
                            backgroundColor: '#f9f9f9',
                            cursor: 'auto',
                            color: 'inherit'
                          }} disabled defaultValue={this.state.to_amt} value={this.state.to_amt} size="large"/> {this.getToDropdown()}
                      </Input.Group>
                    </Form.Item>
                  </Form>
                </Col>
                <Col md={{span: 24}} lg={{span: 6}}>
                  <span className={styles.label}>ESTIMATED DELIVERY:</span>
                  {this.getDeliveryEstimate()}
                </Col>
              </Row>
            );
          break;
          case 2:
            let t1 = this.getCurrencyBySymbol(this.state.to);
            retval = (
              <Row gutter={32}>
                <Col md={{span: 24}} lg={{span: 24}}>
                  <div className={styles.label}>Enter the recipient's {t1.fullName} address:</div>
                  <Form.Item help={'Your '+ t1.name.toUpperCase() +' wallet address'} hasFeedback validateStatus={this.state.address_validation_status} >
                    <Input defaultValue={this.state.to_address} value={this.state.to_address} onChange={this.handleAddressChange} onBlur={this.validateAddress} />
                  </Form.Item>
                </Col>
              </Row>
            )
          break;
          case 3:
            retval = (
              <Row gutter={32}>
                <Col md={{span: 24}} lg={{span: 18}}>
                  <div className={styles.label}>Confirm Transaction Details</div>
                  <div>All transactions are final and non-reversible. Please check and confirm if all the following transaction details are correct:</div>
                  <ul className={styles.confirmInfo}>
                    <li>You are sending <strong>{this.state.from_amt} {this.state.from.toUpperCase()}</strong></li>
                    <li>Recipient will receive an estimated <strong>{this.state.to_amt} {this.state.to.toUpperCase()}</strong> (this amount includes transaction fees)</li>
                    <li>{this.state.to.toUpperCase()} recipient's address is <strong>{this.state.to_address}</strong></li>
                  </ul>
                </Col>
                <Col md={{span: 24}} lg={{span: 6}}>
                  <span className={styles.label}>ESTIMATED DELIVERY:</span>
                  {this.getDeliveryEstimate()}
                </Col>
              </Row>
            );
          break;
          case 4:
          case 5:
            let spin_icon = <Icon type="loading" style={{ fontSize: 32 }} spin />;
            let spinner = <div style={{ display: 'flex', minHeight: 150 }}><Spin indicator={spin_icon} style={{ flex: 1, alignSelf: 'center'}} /></div>;
            let err_gui = <div><h2>Transaction cancelled</h2><Alert message={this.state.trx_error} type="error" showIcon /></div>;
            retval = (
              <Row gutter={32}>
                <Col span={24}>
                    {this.state.trx_busy ? spinner : (this.state.trx_error ? err_gui : this.renderSendMoney()) }
                </Col>
              </Row>
            )
          break;
        }
        return <div className={styles.stepsContent}>{retval}</div>;
      }

      renderTimeline(d, show_gauge) {
        const statuses = [
          {id: "new", message: <Fragment><div>Initiated transaction</div><div>{d.created}</div></Fragment>, next: "Waiting for payment", color: "green"},
          {id: "confirming", message: <Fragment><div>Payment received</div><div>{d.payin_date}</div><div>{d.payin_hash}</div></Fragment>, next: "Waiting for confirmation", color: "green"},
          {id: "confirmed", message: "Payment confirmed", next: "Initiating exchange", color: "green"},
          {id: "exchanging", message: "Order sent to exchange", next: "Exchanging funds...", color: "green"},
          {id: "finished", message: <Fragment><div>Funds successfully sent to the recipient's address</div><div>{d.payout_date}</div><div>{d.payout_hash}</div></Fragment>, color: "green", final: true},
          {id: "failed", message: "Transaction has failed. In most cases, the amount was less than the minimum.", hide: true, final: true, color: "red"},
          {id: "refunded", message: "Exchange process failed and funds were refunded", hide: true, final: true, color: "red"}
        ];
        let current_status = 0;
        let finished_index = 0;
        let timeline_items = [];
        let gauge = null;
        for (let i = 0; i < statuses.length; i++) {
          if(statuses[i].id === d.status) current_status = i;
          if(statuses[i].id === "finished") finished_index = i;
        };
        for (let i = 0; i < statuses.length; i++) {
          if(i < current_status) {
            if(!statuses[i].final)
            timeline_items.push(<Timeline.Item key={"timeline"+i} color={statuses[i].color}>{statuses[i].message}</Timeline.Item>);
          } else if(i === current_status) {
            timeline_items.push(<Timeline.Item key={"timeline"+i} color={statuses[i].color}>{statuses[i].message}</Timeline.Item>);
            if(statuses[i].next) timeline_items.push(<Timeline.Item key={"timeline"+i+"next"} dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }}/> }>{statuses[i].next}</Timeline.Item>);
          } else if(i > current_status) {
            if(!statuses[i].hide)
            timeline_items.push(<Timeline.Item key={"timeline"+i} color="gray">{statuses[i].message}</Timeline.Item>);
          }
        }
        if(show_gauge) {
          let failed = current_status > finished_index;
          let perc = (current_status+1) / (finished_index + 1) * 100;
          let exception = failed ? {status:"exception"} : null;
          gauge = (
            <Fragment>
              <h2>{failed ? 'Failed': (perc === 100 ? 'Completed' : 'Processing')}</h2>
              <div className={styles.progress_gauge}>
                <Progress type="circle" strokeWidth={10} percent={current_status <= finished_index ? perc : 100} gapPosition="bottom" {...exception} gapDegree={90} width={60} />
              </div>
              <Divider/>
            </Fragment>
          )
        }
        return <Fragment>{gauge}<Timeline className={styles.timeline}>{timeline_items}</Timeline></Fragment>;
      }

      renderSendMoney() {
        const d = this.state.trx_data;
        if(!d) return (<div className={styles.send_container}><h2>Invalid Transaction ID</h2>Transaction with ID {this.state.trx_id} does not exist in our records</div>)
        if(d.status === 'new') {
          return (
            <div className={styles.send_container}>
              <div>Transaction ID: {d._id}</div>
              <div className={styles.send_instructions}>Send {d.amount_from} {d.currency_from.toUpperCase()} to the address below
                <div className={styles.send_instructions_sub}>The whole amount should be sent as one transaction!</div>
              </div>
              <div className={styles.send_address}>
                <span className={styles.copy_address}>{d.payin_address}</span>
                <Clipboard className="ant-btn ant-btn-dashed ant-btn-icon-only" data-clipboard-text={d.payin_address} onSuccess={()=>{ notification.success({message: 'Copied!', description: d.payin_address, duration: 1}) }}>
                  <Fragment>Copy <Icon type="copy" /></Fragment>
                </Clipboard>
              </div>
              <Divider style={{height: "auto"}}>Or scan QR-code</Divider>
              <QRCode value={d.payin_address} size={220} />
              {this.renderTimeline(d, false)}
            </div>
          )
        } else {
          return (
            <div className={styles.send_container}>
              <div>Transaction ID: {d._id}</div>
              {this.renderTimeline(d, true)}
            </div>
          )
        }
      }

      repeatTrx() {
        const d = this.state.trx_data;
        if(d) {
          this.setState({ trx_id: null, trx_data: null }, () => {
            this.props.history.push('/exchange/convert/'+ d.currency_from + '/' + d.currency_to + '/' + d.amount_from);
          });
        } else {
          this.props.history.push('/exchange');
        }
      }

      renderPrevNext(current) {
        return (<div className="steps-action">
          {current > 0 && <Button style={{marginRight: 8 }} onClick={() => this.prevStep()}  disabled={!this.state.allow_prev}><Icon type="left" />Back</Button>}
          {current < steps.length - 1 && <Button type="primary" onClick={() => this.nextStep()} disabled={!this.state.allow_next}>{steps[current].nextbtn}<Icon type="right" /></Button>}
          {current === steps.length - 1 && <Button type="primary" onClick={() => this.repeatTrx()}>Repeat Transaction</Button>}
        </div>)
      }

      render() {
        return (
          <Content style={{
              margin: '2em'
            }}>
            <Fragment>
              <h2>Cryptocurrency Exchange</h2>
              <Row>
                <Col lg={{ span: 24 }} xl={{ span: 18, offset:3}}>
                  <Steps current={this.state.step} size="small">
                    {steps.map(item => <Step key={item.title} status={item.status} icon={item.icon} title={item.title} />)}
                  </Steps>
                  {this.renderStep(this.state.step)}
                  {this.renderPrevNext(this.state.step)}
                </Col>
              </Row>
            </Fragment>
          </Content>
        );
      }
    }

    export default inject("main")(observer(Exchange));



// WEBPACK FOOTER //
// ./src/containers/Exchange/Exchange.js